export default () => ({

    type: 'collapse',

    is_collapsed: true,
    is_pinned: false, // by show trigger
    is_stopped: false, // by stop trigger
    is_on_dark: false,

    fixed_panel: null,
    show_trigger: null,
    hide_trigger: null,
    show_offset: null,
    stop_trigger: null,

    scroll_top: 0,
    last_scroll_top: 0,
    scroll_direction: null,

    mobile_translate_y: 0, // текущий inline-сдвиг плашки на мобильном (px)

    panel: {

        /**
         * Динамическая установка CSS-классов
         * @return {{dark: (boolean|*|boolean)}}
         */
        ['x-bind:class']() {
            return {
                'dark': this.is_on_dark,
                'translate-y-full md:-translate-y-full': this.type === 'collapse' && this.is_collapsed,
                'fixed shadow-t md:shadow-none': (() => {

                    if (this.is_stopped) {
                        return false;
                    }

                    if (this.type === 'pin' && this.is_pinned) {
                        return true;
                    }

                    return this.type === 'collapse'
                })(),
            }
        },

        ['x-on:scroll.window']() {
            this.handleScroll();
        },

        ['x-on:touchmove.window']() {
            this.handleScroll();
        },

        ['x-on:resize.window']() {
            this.handleScroll();
        },
    },

    init() {

        // noinspection JSUnresolvedReference
        this.fixed_panel = this.$root;

        // noinspection JSUnresolvedReference
        this.type = this.$root.getAttribute('data-type');

        // noinspection JSUnresolvedReference
        this.show_offset = parseInt(this.$root.getAttribute('data-show-offset')) ?? 0;

        // noinspection JSUnresolvedReference
        const show_trigger_selector = this.$root.getAttribute('data-show-trigger');
        if (show_trigger_selector) {
            this.show_trigger = document.querySelector(show_trigger_selector);
        }

        // noinspection JSUnresolvedReference
        const hide_trigger_selector = this.$root.getAttribute('data-hide-trigger');
        if (hide_trigger_selector) {
            this.hide_trigger = document.querySelector(hide_trigger_selector);
        }

        // noinspection JSUnresolvedReference
        const stop_trigger_selector = this.$root.getAttribute('data-stop-trigger');
        if (stop_trigger_selector) {
            this.stop_trigger = document.querySelector(stop_trigger_selector);
        }

        // Первичный расчёт. handleScroll вешается только на scroll/touchmove,
        // поэтому без этого вызова плашка не появится, если при загрузке триггер
        // уже во вьюпорте (короткая шапка) — состояние оставалось бы классовым
        // (скрытым) до первого касания. $nextTick — чтобы x-cloak уже сняли и
        // layout устоялся.
        this.$nextTick(() => this.handleScroll());

        // Пересчёт при сворачивании адресной строки / изменении visual viewport
        // (resize.window это не всегда ловит на мобильных).
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', () => this.handleScroll());
            window.visualViewport.addEventListener('scroll', () => this.handleScroll());
        }
    },

    /**
     * Обработка события прокрутки
     */
    handleScroll() {

        if (!this.show_trigger) {
            console.debug('[page-fixed-panel] Элемент `show_trigger_element` не найден.');
            return;
        }

        this.last_scroll_top = this.scroll_top;
        this.scroll_top      = document.documentElement.scrollTop;

        this.scroll_direction = this.last_scroll_top < this.scroll_top
            ? 'down'
            : 'up';

        let show_offset = (this.show_trigger.offsetTop ?? 0) + this.show_offset;

        // На мобильном панель выезжает снизу, а на десктопе — сверху.
        // Десктоп: показываем, когда ВЕРХНЯЯ граница viewport проходит триггер
        // (высокая шапка ушла наверх — там же находится кнопка заказа). Этим
        // управляют CSS-классы по флагу is_collapsed.
        //
        // Мобильный: в шапке кнопки нет, единственная кнопка «Купить билет» —
        // это нижняя плашка. Она имитирует sticky-элемент, чья «нормальная»
        // позиция — НА ТРИГГЕРЕ (он стоит сразу после фото/шапки, перед
        // контентом): верхняя кромка плашки совпадает с триггером, пока тот
        // поднимается от нижней кромки экрана вверх на высоту плашки, после чего
        // плашка фиксируется. Геометрию считаем по РЕАЛЬНЫМ rect-ам триггера и
        // самой плашки (см. computeMobileReveal) — это устойчиво к dynamic
        // viewport: оба измеряются в одной системе координат одного кадра.
        const is_mobile = this.hide_trigger && this.hide_trigger.offsetWidth > 0;
        const reveal    = is_mobile ? this.computeMobileReveal() : null;

        if (reveal) {
            this.is_collapsed = this.type === 'collapse' && ! reveal.docked;
            this.is_pinned    = false;
        } else if (is_mobile) {
            // Плашка скрыта на мобильном (`hidden md:block`, когда событие уже
            // началось) — нулевая высота, reveal не посчитать. Ветка десктопа
            // здесь повесила бы `html.fixed-panel`, и чат с кнопкой «Наверх»
            // поднимались бы на высоту несуществующей плашки.
            this.is_collapsed = this.type === 'collapse';
            this.is_pinned    = false;
        } else {
            this.is_collapsed = this.type === 'collapse' && this.scroll_top < show_offset;
            this.is_pinned    = this.type === 'pin' && this.scroll_top >= show_offset;
        }

        if (this.type === 'collapse') {
            if (this.is_collapsed) {
                setTimeout(() => {
                    if (this.is_collapsed) {
                        document.documentElement.classList.remove('fixed-panel');
                    }
                }, 300);
            } else {
                document.documentElement.classList.add('fixed-panel');
            }
        }

        if (this.type === 'pin') {
            if (!this.is_pinned) {
                setTimeout(() => {
                    if (!this.is_pinned) {
                        document.documentElement.classList.remove('fixed-panel');
                    }
                }, 300);
            } else {
                document.documentElement.classList.add('fixed-panel');
            }
        }

        this.is_stopped = false;

        // Если есть триггер остановки
        if (this.stop_trigger && this.stop_trigger.offsetWidth > 0) {

            let scroll_top = this.scroll_top;
            let window_height = window.innerHeight;
            let panel_height = this.fixed_panel.clientHeight;
            let trigger_offset = this.stop_trigger.offsetTop;

            if (scroll_top + window_height - panel_height * 2 > trigger_offset) {
                this.is_stopped = true;
                document.documentElement.classList.remove('fixed-panel');
            }
        }

        // Если есть триггер скрытия
        let force_hidden = false;
        if (this.hide_trigger && this.hide_trigger.offsetWidth > 0) {

            let scroll_top = this.scroll_top;
            // Та же геометрия `fixed bottom:0`, что и при показе — меряем нижнюю
            // кромку по layout viewport (clientHeight), а не visual (innerHeight)
            let window_height = document.documentElement.clientHeight;
            let panel_height = this.fixed_panel.clientHeight;
            let trigger_offset = this.hide_trigger.offsetTop;

            // Скрывать плашку позднее, если расстояние небольшое
            if(this.hide_trigger.offsetTop - this.show_trigger.offsetTop < 1024){
                trigger_offset += 512;
            }

            if (scroll_top + window_height - panel_height * 2 > trigger_offset) {
                this.is_pinned = false;
                this.is_collapsed = true;
                force_hidden = true;
                document.documentElement.classList.remove('fixed-panel');
            }
        }

        this.applyMobileReveal(reveal, is_mobile, force_hidden);

    },

    /**
     * Геометрия мобильного «sticky»-появления.
     *
     * Все координаты — ВИЗУАЛЬНЫЕ:
     *   - триггер (обычный элемент) даёт верную визуальную позицию через
     *     getBoundingClientRect().top;
     *   - низ видимой области = visualViewport.offsetTop + visualViewport.height;
     *   - `position: fixed; bottom: 0` плашка визуально стоит на этом низу
     *     (хотя её getBoundingClientRect.top для fixed возвращает layout-низ и
     *     ему ВЕРИТЬ НЕЛЬЗЯ — поэтому позицию плашки мы НЕ измеряем);
     *   - translateY двигает плашку визуально 1:1.
     *
     * Док-линия (верх плашки в доке) = visible_bottom − panel_height. Пока
     * триггер (низ картинки) ниже этой линии — верх плашки приклеен к триггеру
     * (плашка выезжает из-под картинки 1:1 со скроллом, translateY ≥ 0 вниз),
     * как только триггер дошёл до линии — плашка пристыкована (reveal = 0).
     *
     * Никакой компенсации `bottom` не нужно: fixed-низ и так совпадает с
     * визуальным низом, а ориентир дока берём от visualViewport — поэтому при
     * сворачивании адресной строки плашка остаётся заподлицо без рывков.
     *
     * @return {{reveal: number, panel_height: number, docked: boolean}|null}
     */
    computeMobileReveal() {

        const panel_height = this.fixed_panel.clientHeight;
        if (!panel_height) {
            return null;
        }

        const vv             = window.visualViewport;
        const visible_bottom = vv ? (vv.offsetTop + vv.height) : document.documentElement.clientHeight;
        const trigger_top    = this.show_trigger.getBoundingClientRect().top;

        const dock_top = visible_bottom - panel_height; // верх плашки в доке

        // reveal: 0 — пристыкована, растёт по мере того как триггер опускается
        // ниже доковой линии (плашка уезжает вниз вслед за низом картинки).
        let reveal = trigger_top - dock_top;
        if (reveal < 0) {
            reveal = 0;
        } else if (reveal > panel_height) {
            reveal = panel_height;
        }

        return { reveal, panel_height, docked: reveal === 0 };
    },

    /**
     * Применение мобильного «sticky»-появления.
     *
     * На десктопе плашка «вылетает» сверху по CSS-переходу — этим управляют
     * классы, поэтому здесь только снимаем inline-стили.
     *
     * На мобильном `transform` (translateY) отвечает за выкат снизу синхронно
     * со скроллом; ориентир — visualViewport, поэтому компенсация `bottom` не
     * нужна (см. computeMobileReveal).
     *
     * @param {{reveal: number, panel_height: number, docked: boolean}|null} reveal
     * @param {boolean} is_mobile    Мобильный режим (виден триггер скрытия)
     * @param {boolean} force_hidden Принудительно убрать вниз (триггер скрытия)
     */
    applyMobileReveal(reveal, is_mobile, force_hidden) {

        const style = this.fixed_panel.style;

        // Десктоп: отдаём управление CSS-классам (выезд сверху)
        if (!is_mobile || !reveal) {
            style.removeProperty('transform');
            style.removeProperty('transition');
            this.mobile_translate_y = 0;
            return;
        }

        // force_hidden — увод вниз у конца страницы: единственный случай, где
        // нужен плавный CSS-переход. При выкате со скроллом перехода нет, иначе
        // плашка «догоняет» скролл с задержкой и эффект sticky теряется.
        const translate_y = force_hidden ? reveal.panel_height : reveal.reveal;

        if (force_hidden) {
            style.removeProperty('transition'); // вернуть переход из класса (300ms)
        } else {
            // `!important` нужен, т.к. класс перехода тоже объявлен через `!`.
            style.setProperty('transition', 'none', 'important');
        }

        if (translate_y === 0) {
            // Пристыкована: transform:none не создаёт containing block, чтобы
            // вложенная `fixed`-панель вкладок репертуаров позиционировалась
            // относительно окна, а не плашки. `!important` перебивает класс
            // `translate-y-full` без мигания.
            style.setProperty('transform', 'none', 'important');
        } else {
            style.setProperty('transform', `translateY(${translate_y}px)`, 'important');
        }

        this.mobile_translate_y = translate_y;
    },

});
